import { h } from 'preact';
import MinusIcon from '../utils/icon/minus.svg';
import PlusIcon from '../utils/icon/plus.svg';

const ProductQuantity = ({ quantity, changeQuantity, maxOrder }) => {
  const setNewQty = (qty) => {
    if (qty && qty < 1) {
      changeQuantity(1);
      return;
    }
    if (maxOrder && qty && qty >= maxOrder) {
      changeQuantity(maxOrder);
      return;
    }

    changeQuantity(qty);
  };
  const onBlur = () => {
    if (!quantity) {
      setNewQty(1);
    }
  };

  return (
    <div
      className="flex w-[114px] h-[50px] border border-black mr-2.5"
      onBlur={onBlur}
      tabIndex={-1}
    >
      <button
        type="button"
        aria-label={window.TMW.Strings.product.decreaseQuantity}
        className="flex justify-center items-center w-8 focus:ring-offset-0 disabled:text-grey-8"
        disabled={quantity < 2}
        onClick={() => setNewQty(quantity - 1)}
      >
        <MinusIcon />
      </button>
      <input
        type="number"
        value={quantity}
        aria-label={window.TMW.Strings.product.quantityInput}
        className="border-0 w-8 text-center text-headline-tag px-0 focus:ring-offset-0 focus:ring-0 select-none"
        onChange={(e) => setNewQty(e.target.value)}
        readOnly
      />
      <button
        type="button"
        aria-label={window.TMW.Strings.product.increaseQuantity}
        className="flex justify-center items-center w-[34px] lg:w-10 focus:ring-offset-0 disabled:text-grey-8"
        disabled={quantity >= maxOrder}
        onClick={() => setNewQty(quantity + 1)}
      >
        <PlusIcon />
      </button>
    </div>
  );
};

export default ProductQuantity;
